import billingPlansTableTemplate from './billing-plans-table.tpl.html';
import './billing-plans-table.less';

const groups = [
  { id: undefined, label: 'Platform' },
  { id: 'content', label: 'Content' },
  { id: 'team', label: 'Teamwork' },
  { id: 'integrate', label: 'Integrate' },
  { id: 'support', label: 'Support' },
];

export const billingPlansTableComponentModule = angular
  .module('Q.components.billing-plans-table', [])

  .component('billingPlansTable', {
    bindings: {
      plans: '<',
      onSelect: '&',
      customer: '<',
      showBurst: '<',
      hideFeatures: '<',
      landing: '<',
    },
    controller: 'BillingPlansTableCtrl',
    template: billingPlansTableTemplate,
  })

  .controller('BillingPlansTableCtrl', function BillingPlansTableCtrl() {
    const ctrl = this;

    ctrl.width = () => 100 / (ctrl.plans.length + 1) + '%';

    ctrl.selected = 0;
    ctrl.nextPlan = () => {
      ctrl.selected = (ctrl.selected + 1) % ctrl.plans.length;
    };
    ctrl.prevPlan = () => {
      ctrl.selected =
        (ctrl.selected + ctrl.plans.length - 1) % ctrl.plans.length;
    };

    ctrl.$onInit = () => {
      ctrl.baseTrackingKey = ctrl.customer ? 'hire' : 'landing';
      ctrl.showFeatures = !ctrl.hideFeatures;
      setFeatures();

      ctrl.$onChanges = setFeatures;
    };

    function setFeatures() {
      // sort the features by plan, so that each plan's unique features are clustered together
      let features = [];
      if (ctrl.plans[0]) {
        let list = ctrl.plans[0].featuresList;
        // if we want to show the actual burst prices, then hide the generic feature
        if (ctrl.showBurst) delete list.burstUsage;

        angular.forEach(list, (feature, key) => {
          feature.key = key;
          features.push(feature);
          for (let i = 1; i < ctrl.plans.length; i++) {
            if (ctrl.plans[i - 1].featuresList[key].enabled) {
              feature.priority = i;
              return;
            }
          }
        });
      }

      ctrl.features = features.sort((a, b) => {
        if (a.priority === b.priority) {
          if (a.image || b.image) {
            if (a.image && b.image) {
              return a.key > b.key ? 1 : -1;
            }
            return a.image && !b.image ? -1 : 1;
          }
          return a.displayName > b.displayName ? 1 : -1;
        }
        return a.priority > b.priority ? 1 : -1;
      });

      ctrl.seatsTooltip = (plan) => {
        let tips = [];
        if (plan.additionalPremiumSeatPriceFloat > 0) {
          tips.push(
            `$${plan.additionalPremiumSeatPriceFloat} a month per additional manager seat`,
          );
        }
        if (plan.additionalRestrictedSeatPriceFloat > 0) {
          tips.push(
            `$${plan.additionalRestrictedSeatPriceFloat} a month per additional reviewer seat`,
          );
        }

        return tips.join(', ');
      };

      ctrl.groups = groups.map((g) => {
        g.features = ctrl.features.filter((f) => f.group === g.id);
        return g;
      });
    }
  });
